<script>
import confetti from "canvas-confetti";

export default {
  data() {
    return {};
  },
  components: {},
  beforeUpdate() {
    document.title = "UNIFI Property: Congratulations";
  },
  created() {
    document.title = "UNIFI Property: Congratulations";
    this.confettiAnimation()
  },
  methods: {
    returnToHome() {
      this.$router.push({ path: "/uconnect/search/results" });
    },
    confettiAnimation() {
      confetti({
        particleCount: 200,
        angle: 60,
        spread: 70,
        origin: { x: 0 }
      });
      // and launch a few from the right edge
      confetti({
        particleCount: 200,
        angle: 120,
        spread: 70,
        origin: { x: 1 }
      });
    },
  },
};
</script>

<template>
  <el-row style="padding: 20px 0">
    <el-col :span="24">
      <el-row>
        <el-col :span="24" style="margin-top: 20px">
          <span class="title-confirmation-selection">Congratulations!</span>
        </el-col>
<!--        <el-col-->
<!--          :span="24"-->
<!--          style="margin-top: 24px; display: flex; justify-content: center;"-->
<!--        >-->
<!--          <el-image-->
<!--            :src="require('../../../static/img/similar-search-1.jpg')"-->
<!--            fit="fill"-->
<!--            style="max-height: 582px; max-width: 1544px; border-radius: 0 0 30px 30px; box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.5);"-->
<!--          />-->
<!--        </el-col>-->
      </el-row>
    </el-col>
    <el-col :span="24">
      <el-row>
        <el-col :span="24" style="margin-top: 24px">
          <span class="para-confirmation-selection"
            >Congratulations on taking the first step in your property
            purchase.</span
          >
        </el-col>
        <el-col :span="24" style="margin-top: 24px">
          <span class="para-confirmation-selection"
            >Your agent will be in touch with you shortly to discuss the next
            steps.</span
          >
        </el-col>
        <el-col
          :span="24"
          style="margin-top: 20px; display: flex; justify-content: center"
        >
          <el-button class="btn-return-home" @click="returnToHome"
            >Return Home</el-button
          >
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.title-confirmation-selection {
  color: #003333;
  font: 600 50px DINosaur-a, sans-serif;
  display: flex;
  justify-content: center;
}

.para-confirmation-selection {
  color: #003333;
  font: 400 22px DINosaur-a, sans-serif;
  display: flex;
  justify-content: center;
}

.btn-return-home {
  border-top-right-radius: 30px;
  border: 3px solid #003333;
  background-color: #003333;
  color: #ffffff;
  text-align: center;
  padding: 10px 100px;
  font: 400 22px/125% DINosaur-a, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/uConnectReservation/confirmationSection.vue